<template>
  <div class="wrapper">
    <textarea
      class="form-control"
      :id="getFieldID(schema)"
      :class="schema.fieldClasses"
      :value="value"
      @input="value = $event.target.value"
      @change="onChange"
      :disabled="disabled"
      :maxlength="schema.max || schema.maxlength"
      :minlength="schema.min || schema.minlength"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
      :required="schema.required"
      :rows="schema.rows || 2"
      :name="schema.inputName"
    ></textarea>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  // Vue 3 compat note:
  // we use explicit :value/@input here instead of the legacy VFG textarea v-model path,
  // which caused runtime assignment errors in compat mode.
  mixins: [abstractField],

  methods: {
    onChange() {
      if (this.schema.onChange) {
        this.schema.onChange();
      }
    },
  },
};
</script>
